define("settings/components/billing-section", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/compare-strings", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _compareStrings, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/compare-strings",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Section
    @badge={{@badge}}
    @qaClass="qa--subHeader_billing"
    @title={{t "account.billing.section_title"}}
    {{did-insert (perform this.loadPayments)}}
    as |section|
  >
  
    <section.wrapper>
      {{#if this.hasBillingErrors}}
        <section.details
          @description={{t "account.billing.error"}}
          @descriptionStyles="u--text--danger"
          @title={{t "account.billing.title"}}
          @titleStyles="u--text--md u--text--danger"
        />
      {{else}}
        <section.details
          @description={{t "account.billing.description"}}
          @descriptionStyles="u--text--light"
          @title={{t "account.billing.title"}}
          @titleStyles="u--text--md"
        />
      {{/if}}
      <section.action @buttonRoute="subscription.billing" @buttonText={{t "account.billing.button"}} />
    </section.wrapper>
  
  </Section>
  */
  {
    "id": "g7VNXywW",
    "block": "[[[8,[39,0],[[4,[38,2],[[28,[37,3],[[30,0,[\"loadPayments\"]]],null]],null]],[[\"@badge\",\"@qaClass\",\"@title\"],[[30,1],\"qa--subHeader_billing\",[28,[37,1],[\"account.billing.section_title\"],null]]],[[\"default\"],[[[[1,\"\\n\\n  \"],[8,[30,2,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"hasBillingErrors\"]],[[[1,\"      \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[28,[37,1],[\"account.billing.error\"],null],\"u--text--danger\",[28,[37,1],[\"account.billing.title\"],null],\"u--text--md u--text--danger\"]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[30,2,[\"details\"]],null,[[\"@description\",\"@descriptionStyles\",\"@title\",\"@titleStyles\"],[[28,[37,1],[\"account.billing.description\"],null],\"u--text--light\",[28,[37,1],[\"account.billing.title\"],null],\"u--text--md\"]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[8,[30,2,[\"action\"]],null,[[\"@buttonRoute\",\"@buttonText\"],[\"subscription.billing\",[28,[37,1],[\"account.billing.button\"],null]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"]],[2]]]]]],[\"@badge\",\"section\"],false,[\"section\",\"t\",\"did-insert\",\"perform\",\"if\"]]",
    "moduleName": "settings/components/billing-section.hbs",
    "isStrictMode": false
  });
  let BillingSectionComponent = _exports.default = (_class = class BillingSectionComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "payment", _descriptor, this);
      _defineProperty(this, "payments", []);
      _defineProperty(this, "loadPayments", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.payments = yield this.payment.retrieve.perform();
        }
      }), null, "loadPayments", null));
    }
    get hasBillingErrors() {
      return this.hasPaymentErrors && this.payment.hasErrorLoadingData;
    }
    get hasPaymentErrors() {
      return this.payments && !this.payments.every(payment => (0, _compareStrings.areStringsEqual)(payment.status, 'succeeded'));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BillingSectionComponent);
});